import { create } from "zustand";

type PasswordState = {
	forgotSuccess: boolean | null;
	resetSuccess: boolean | null;
	pendingResetRequest: {
		email: string;
		password: string;
	} | null;
	setForgotSuccess: (value: boolean | null) => void;
	setResetSuccess: (value: boolean | null) => void;
	setPendingResetRequest: (value: { email: string; password: string } | null) => void;
	clear: () => void;
};

export const usePasswordStore = create<PasswordState>((set) => ({
	forgotSuccess: null,
	resetSuccess: null,
	pendingResetRequest: null,
	setForgotSuccess: (value) => set({ forgotSuccess: value }),
	setResetSuccess: (value) => set({ resetSuccess: value }),
	setPendingResetRequest: (value) => set({ pendingResetRequest: value }),
	clear: () => set({ forgotSuccess: null, resetSuccess: null, pendingResetRequest: null }),
}));
